import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/ui/AboutPage.jsx");
